import {
  type Overview,
  OverviewSchema,
  type SidebarCounts,
  SidebarCountsSchema,
} from '@voll-intelligence/domain';

import type { HttpService } from '@web/data/services';

interface OverviewRepository {
  loadOverview: (orgId: string) => Promise<Overview>;
  /** Sidebar count badges (overview / triage / per-squad) in one request. */
  loadSidebarCounts: (orgId: string) => Promise<SidebarCounts>;
}

export function createOverviewRepository(http: HttpService): OverviewRepository {
  return {
    loadOverview: (orgId) => http.get(`/orgs/${orgId}/overview`, { schema: OverviewSchema }),
    loadSidebarCounts: (orgId) =>
      http.get(`/orgs/${orgId}/sidebar-counts`, { schema: SidebarCountsSchema }),
  };
}
